import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import { mapProps, compose } from 'recompose'
import { Button } from 'react-toolbox/lib/button'

import styles from './styles.scss'
import { ROUTE_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'


const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      ROUTE_ROLES.DATA_MANAGER
    ]
  })),
  showOnAnyRoles
)

const RestrictedButton = showToTeam(Button)

const AddButton = props => {
  return (
    <Flex styleName='addButtonContainer' justify='flex-end'>
      <RestrictedButton
        icon='add'
        onClick={props.onClick}
      />
    </Flex>
  )
}

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default CSSModules(AddButton, styles)
